import { SiguUpOne, SiguUpTwo } from "@/Utils/BaseUrl";
import { useTranslation } from "react-i18next";

const SignUpStepOne = ({ next, setIsSeller,setStep }) => {
  const {t}= useTranslation()
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="border rounded-[10px] p-6 flex flex-col items-center text-center justify-between">
          <img src={SiguUpOne} alt="customer" className="h-[120px] mb-4" />
          <h3 className="text-[16px] font-semibold text-[#0C0A20]">
            {t("Register as Customer")}
          </h3>
          <p className="text-[13px] text-[#6B7280] mt-2 mb-6">
           {t("Shop your favorite products, track orders, and get personalized recommendations.")}
          </p>
          <button
            onClick={() => {
              setIsSeller(false);
              next();
            }}
            className="h-[40px] cursor-pointer px-6 rounded-[6px] bg-blue-600 text-white text-[14px] font-medium"
          >
            {t("Continue as Customer")}
          </button>
        </div>

        <div className="border rounded-[10px] p-6 flex flex-col items-center text-center justify-between">
          <img src={SiguUpTwo} alt="seller" className="h-[120px] mb-4" />
          <h3 className="text-[16px] font-semibold text-[#0C0A20]">
            {t("Register as Seller")}
          </h3>
          <p className="text-[13px] text-[#6B7280] mt-2 mb-6">
            {t("Start selling your products to millions of customers worldwide.")}
          </p>
          <button
            onClick={() => {
              setIsSeller(true);
              next();
            }}
            className="h-[40px] cursor-pointer px-6 rounded-[6px] bg-blue-600 text-white text-[14px] font-medium"
          >
            {t("Continue as Seller")}
          </button>
        </div>
      </div>
    </>
  );
};

export default SignUpStepOne;
